import { Stack, Typography } from '@mui/material';

export default function ListHeader({ currentDay, currentDate }: Readonly<{ currentDay: string; currentDate: string }>) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ width: '100%', alignContent: 'center', alignItems: 'center', justifyContent: 'space-between' }}
    >
      <Typography variant="h6">{currentDay}</Typography>
      <Typography variant="caption">{currentDate}</Typography>
    </Stack>
  );
}
